import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IdpCLaimsServiceProxy } from '@shared/service-proxies/service-proxies';
import { IdentityAuthProviderService } from '@app/shared/common/auth/identity-auth-provider.service';
import { IAddedDisclosure, IUpdateAdditionalDisclosure, IUserAdditionalDisclosure } from '@app/shared/models/elevate-data-models';
import { UNDERWRITTEN_MAXIMUM_PREFIX } from '@app/shared/models/policy-case-underwritten-maximums';

@Injectable({ providedIn: 'root' })
export class PolicyCaseUnderwrittenMaximumsService {
    constructor(
        private idpClaimsService: IdpCLaimsServiceProxy,
        private authProvider: IdentityAuthProviderService,
    ) { }

    public getUnderwrittenMaximums(userId: string): Observable<IUserAdditionalDisclosure[]> {
        return this.idpClaimsService
            .getUserAdditionalDisclosures(userId, this.authProvider.user.access_token)
            .pipe(map(disclosures => disclosures.filter(d => d.disclosureType.startsWith(UNDERWRITTEN_MAXIMUM_PREFIX))));
    }

    public saveUnderwrittenMaximum(userId: string, coverKey: string, value: string, disclosureGroupId?: string): Observable<IAddedDisclosure[]> {
        const request: IUpdateAdditionalDisclosure = {
            accessToken: this.authProvider.user.access_token,
            userId,
            addOrUpdateDisclosures: [{
                index: 0,
                disclosureGroupId,
                disclosureType: `${UNDERWRITTEN_MAXIMUM_PREFIX}${coverKey}`,
                disclosureValue: value,
            }],
            deleteDisclosures: [],
        };
        return this.idpClaimsService.updateUserAdditionalDisclosures(request);
    }

    public deleteUnderwrittenMaximum(userId: string, disclosureGroupId: string): Observable<IAddedDisclosure[]> {
        const request: IUpdateAdditionalDisclosure = {
            accessToken: this.authProvider.user.access_token,
            userId,
            addOrUpdateDisclosures: [],
            deleteDisclosures: [{ disclosureGroupId }],
        };
        return this.idpClaimsService.updateUserAdditionalDisclosures(request);
    }
}
